import { withBoundField } from "../form/BoundField/BoundField";
import * as React from "react";
import AutoComplete, { AutoCompleteProps } from "../AutoComplete";

export const BoundAutoComplete = withBoundField((props: AutoCompleteProps) => (
    <div style={{ display: "flex", alignItems: "baseline", width: "100%" }}>
        <AutoComplete {...props} />
    </div>
));
